module.exports = __webpack_public_path__ + "media/azelaic-small.e82488ce.mp4";